import { z } from 'zod';
import { BaseErrorSchema } from 'libs/end-to-end/src/types/errors/base-error-schema';

export const S3StorageDownloadError = BaseErrorSchema.extend({
  errorType: z.literal('S3StorageDownloadError'),
  bucketName: z.string(),
  bucketRegion: z.string(),
  key: z.string(),
  destination: z.string().nullable(),
  errorReason: z.string(),
});

export type S3StorageDownloadError = z.infer<typeof S3StorageDownloadError>;
